// src/hooks/useNotifier.js
// Version: 1.0.0
import { useContext } from 'react';
import { NotificationContext } from '../contexts/NotificationContext';

export const useNotifier = () => useContext(NotificationContext);
